// Simple PHP API layer
// Adjust BASE_URL according to your backend PHP deployment.
// Example for XAMPP: http://localhost/liveclass-api/api.php
const BASE_URL = 'https://gantasoft.in/lmslive/api.php';

async function apiRequest(resource, action, method = 'GET', body) {
  let url = `${BASE_URL}?resource=${resource}&action=${action}`;
  const options = { method, headers: {} };

  if (method !== 'GET' && body) {
    options.headers['Content-Type'] = 'application/json';
    options.body = JSON.stringify(body);
  }

  const res = await fetch(url, options);
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`API error: ${res.status} ${text}`);
  }
  return res.json();
}

export async function loginUserAPI(name, email) {
  return apiRequest('auth', 'login', 'POST', { name, email });
}

export async function createRoomAPI(teacherId) {
  return apiRequest('rooms', 'create', 'POST', { teacher_id: teacherId });
}

export async function joinRoomAPI(roomCode, userId) {
  return apiRequest('rooms', 'join', 'POST', { room_code: roomCode, user_id: userId });
}

export async function saveRecordingAPI(recording) {
  // recording: { user_id, room_code, title, duration, video_url (optional) }
  return apiRequest('recordings', 'create', 'POST', recording);
}

export async function getRecordingsAPI(userId) {
  return apiRequest('recordings', 'list', 'POST', { user_id: userId });
}

export async function sendChatMessageAPI(roomCode, userId, userName, message) {
  return apiRequest('chat', 'send', 'POST', {
    room_code: roomCode,
    user_id: userId,
    user_name: userName,
    message,
  });
}

export async function listChatMessagesAPI(roomCode, sinceTimestamp) {
  return apiRequest('chat', 'list', 'POST', {
    room_code: roomCode,
    since: sinceTimestamp,
  });
}

// --- SIGNALING (PHP-based) ---

export const sendSignalAPI = (roomCode, fromUserId, toUserId, type, payload) =>
  apiRequest('signal', 'send', 'POST', {
    room_code: roomCode,
    from_user_id: fromUserId,
    to_user_id: toUserId,   // or null for broadcast
    type,                   // 'offer' | 'answer' | 'candidate'
    payload,                // plain SDP or ICE object (will be JSON.stringified in PHP)
  });

export const pollSignalsAPI = (roomCode, userId, lastId) =>
  apiRequest('signal', 'poll', 'POST', {
    room_code: roomCode,
    user_id: userId,
    last_id: lastId,
  });

// --- ROOM PARTICIPANTS (for deciding who calls whom) ---

export const getRoomParticipantsAPI = (roomCode) =>
  apiRequest('rooms', 'participants', 'POST', {
    room_code: roomCode,
  });
